module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAATBAMAAABSLiGnAAAAIVBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmOFP9JAAAACnRSTlMAAZH4ccNJSO7EesqTkQAAAFFJREFUCNdjYGBgdBFgAAGhVYogilFr1SIBEHfxKitFENdsVfIiASC3YBUbUMDLnGEVQ/ISBo8CIM3eAtKxCohJpkPBdCiQgKBVEMAQBaZWAgBkXB3WI9zEvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_shangchuan.png
// module id = s9ds
// module chunks = 2